import {Link} from "react-router-dom";
import Logo from "../../assets/LogoPrincipal.png"
import Styles from "./cadastro.module.css"
import {useTranslation} from "react-i18next";

export default function CadastroFinalizado(): JSX.Element {

    const { t } = useTranslation();

    return (
        <div>
            <div className={Styles.container}> 
                <div className={Styles.cadastroHead}>
                        <img src={Logo}/>
                </div>
                <div className={Styles.cadastroBody}>
                        <img src={Logo}/>
                </div>
                <div className={Styles.cadastroFooter}>
                        <p className={Styles.CadastroFinalizado}>{t('cadastrofinalizado.cadastro')}</p>
                        <p className={Styles.Tela}>{t('cadastrofinalizado.descricao')}</p>
                        <p className={Styles.Tela}>
                            {t('cadastrofinalizado.ir')}{' '}
                            <Link to={'/login'}>
                                {t('cadastrofinalizado.login')}
                            </Link>
                        </p>
                </div>
            </div>
        </div>
    );
}